import { MetaData, SpecialistsPage } from '@/components'
import stripUnrenderedDirectionImages from '@/lib/stripUnrenderedDirectionImages'

function directionsWithDoctors(directions) {
  return (directions || []).filter((direction) => {
    if (!direction || direction.specialist_count == null || direction.specialist_count === '') return true
    return Number(direction.specialist_count) > 0
  })
}

export default function NextSpecialistsPage(props) {
  const paginator = props.paginator || {};
  const meta  = paginator.meta || {};
  const { title: titleFromProps, description: descFromProps } = meta;
  const title = titleFromProps || "ELEMENTAL Day Surgical Center Specialists";
  const description = descFromProps || "ELEMENTAL Day Surgical Center"

  return (
    <>
      <MetaData title={title} description={description}/>
      <SpecialistsPage {...props} />
    </>
  )
}

NextSpecialistsPage.getInitialProps = async ({ query, api }) => {
  const { page, ...queries } = query
  const response = await api.specialists(page, queries)

  const { directions, ...paginator } = response
  const visibleDirections = directionsWithDoctors(directions)
  stripUnrenderedDirectionImages({ directions: visibleDirections })
  return { directions: visibleDirections, paginator }
}
